import { fetchJson } from "src/utils/apiUtils";
import {
  IUserProductPaginateReq,
  IUserProductBrief,
  IUserProductContainer,
  IUserProductSaveReqContainer
} from "./types";

const endpoint = `userProducts`;

export const listUserProducts = async (search: IUserProductPaginateReq) => {
  return fetchJson<IResponse<IPaginateResponse<IUserProductBrief>>>(
    `${endpoint}/listPaginate`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const getUserProduct = async (id: UserProductId) => {
  return fetchJson<IResponse<IUserProductContainer>>(`${endpoint}/${id}`, {
    method: "GET"
  });
};

export const updateUserProduct = async (
  id: UserProductId,
  req: IUserProductSaveReqContainer
) => {
  return fetchJson<IResponse<UserProductId>>(`${endpoint}/save/${id}`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};
